// extracted by mini-css-extract-plugin
export default {"page":"Frank_page__LPAJl"};